<template>
  <v-container fluid>
    <v-layout row>
      <v-flex xs12 md10 offset-md1 lg8 offset-lg2>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item :to="{ name: 'my-services' }" exact>Mine tjenester</v-breadcrumbs-item>
          <v-breadcrumbs-item :to="{ name: 'mekke-list' }" exact>Mekke Publisering</v-breadcrumbs-item>
          <v-breadcrumbs-item disabled>{{ state.servername }}</v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
        <notifications group="mekke-detail" key="mekke-detail" />

        <v-form>
          <v-card class="pa-3" raised>
            <h3>Informasjon</h3>

            <v-text-field
              label="Domene"
              v-model="state.servername"
              readonly
            ></v-text-field>
            <v-text-field
              label="Brukernavn"
              v-model="state.username"
              readonly
            ></v-text-field>
            <v-text-field
              label="E-post"
              v-model="state.email"
              readonly
            ></v-text-field>
          </v-card>

          <v-card class="pa-3 mt-3" raised>
            <h3>Sett nytt passord</h3>

            <password-input
              :confirm="true"
              :numCharacters="8"
              @passwordChanged="passwordChanged"
            />

            <v-card-actions>
              <v-btn
                @click="updatePassword"
                :disabled="!this.password"
              >
                Sett nytt passord
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MekkeService from '@/services/MekkeService'

export default {
  mounted () {
    this.init()
  },
  data () {
    return {
      isSubmitting: false,
      password: '',
      state: {}
    }
  },
  methods: {
    async init () {
      const response = await this.runService(this, 'mekke-detail', MekkeService.get, this.servername)
      if (response) {
        this.state = response.data
      }
    },
    async updatePassword () {
      const response = await this.runService(this, 'mekke-detail', MekkeService.updatePassword, this.servername, this.password)
      if (response) {
        this.goBack('Passordet ble oppdatert!')
      }
    },
    goBack (successMessage) {
      if (successMessage) {
        this.addNotification(false, {
          group: 'mekke-list',
          type: 'success',
          text: successMessage
        })
      }
      this.$router.push({ name: 'mekke-list' })
    },
    passwordChanged (v) {
      this.password = v
    }
  },
  computed: {
    servername () {
      return this.$route.params.servername
    }
  }
}
</script>
